import React from 'react'

// next components
import { useRouter } from 'next/router'

// third party components
import { useDispatch } from 'react-redux'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'
import { useWallet } from '@solana/wallet-adapter-react'

import EcosystemIcon from 'assets/icons/ecosystem-icon.svg?component'
import NftCategoryIcon from 'assets/icons/dashboard-icon.svg?component'
import NftCollectionIcon from 'assets/icons/collection-icon.svg?component'
import NftArtistIcon from 'assets/icons/artist-icon.svg?component'
import CreatorIcon from 'assets/icons/creator-icon.svg?component'
import CollectorIcon from 'assets/icons/collector-icon.svg?component'
import MobileEAIcon from 'assets/icons/create-ea-icon-mobile.svg?component'
import MobileMerchIcon from 'assets/icons/create-merch-icon-mobile.svg?component'
import BrowseIcon from 'assets/icons/menu-browse-icon.svg?component'
import LeaderboardIcon from 'assets/icons/menu-leaderboard-icon.svg?component'
import GenreIcon from 'assets/icons/menu-genre-icon.svg?component'
import SingleNftIcon from 'assets/icons/menu-single-nft-icon.svg?component'
import EditionIcon from 'assets/icons/menu-edition-nft-icon.svg?component'
import FineArtIcon from 'assets/icons/menu-fine-art-icon.svg?component'
import PrintsIcon from 'assets/icons/menu-prints-icon.svg?component'
import ApparelIcon from 'assets/icons/menu-store-item-icon.svg?component'

// styles
import styles from './index.module.scss'

const AccordionMenu = props => {
  const { type = '', data, path = '', username = '' } = props

  const router = useRouter()
  const dispatch = useDispatch()
  const { setVisible } = useWalletModal()
  const { connected } = useWallet()

  const handleClick = item => {
    dispatch({ type: 'set', openMobileMenu: false })

    if (type === 'explore') {
      if (item.type === 'leaderboard') dispatch({ type: 'set', activeTab: 2 })
      else if (item.type === 'genre') {
        dispatch({ type: 'set', openCategorySelection: true })
        return
      }
    }

    if (type === 'shop') {
      if (item.type === 'fine_art') {
        dispatch({ type: 'set', exploreTab: 0 })
        dispatch({ type: 'set', availabilityFilter: 0 })
      }
    }

    if (type === 'leaderboards') {
      if (item.type === 'stats_artist') dispatch({ type: 'set', activeTab: 0 })
      else if (item.type === 'stats_collections') dispatch({ type: 'set', activeTab: 1 })
      else if (item.type === 'stats_creators') dispatch({ type: 'set', activeTab: 2 })
      else if (item.type === 'stats_collectors') dispatch({ type: 'set', activeTab: 3 })
    }

    if (type === 'create') {
      if (!connected) {
        setVisible(true)
        return
      }
      if (item.type === 'single_nft') dispatch({ type: 'set', createTab: 0 })
      else if (item.type === 'edition') dispatch({ type: 'set', createTab: 1 })
      else if (item.type === 'collection_nft') {
        dispatch({ type: 'set', mintCollectionStep: 1 })
        dispatch({ type: 'set', collectionMintAddress: '' })
        dispatch({ type: 'set', collectionCoverUrl: '' })
        dispatch({ type: 'set', collectionKind: 'foster' })
      } else if (item.type === 'collection_ea') {
        dispatch({ type: 'set', mintCollectionStep: 1 })
        dispatch({ type: 'set', collectionMintAddress: '' })
        dispatch({ type: 'set', collectionCoverUrl: '' })
        dispatch({ type: 'set', collectionKind: 'ea' })
      } else if (item.type == 'studio') {
        router.push(`/${username.replaceAll(' ', '%20')}/merch/new`)
        return
      }
    }

    router.push(item.path)
  }

  const getTypeIcon = type => {
    switch (type) {
      case 'merch':
        return <MobileMerchIcon />
      case 'nft_category':
        return <EcosystemIcon />
      case 'stats_collections':
        return <NftCollectionIcon />
      case 'browse':
        return <BrowseIcon />
      case 'leaderboard':
        return <LeaderboardIcon />
      case 'genre':
        return <GenreIcon />
      case 'fine_art':
        return <FineArtIcon />
      case 'prints':
        return <PrintsIcon />
      case 'apparel':
        return <ApparelIcon />
      case 'stats_artwork':
        return <NftArtistIcon />
      case 'single_nft':
        return <SingleNftIcon />
      case 'edition':
        return <EditionIcon />
      case 'collection_nft':
        return <NftCategoryIcon />
      case 'collection_ea':
        return <MobileEAIcon />
      case 'studio':
        return <MobileMerchIcon />
      case 'stats_creators':
        return <CreatorIcon />
      case 'stats_collectors':
        return <CollectorIcon />
      default:
        return <div />
    }
  }
  return (
    <div className="w-full">
      {data.map((item, index) => (
        <div key={index} className={styles.menuItem} onClick={() => handleClick(item)}>
          <div className="w-full flex items-center">
            <div className={styles.icon}>
              <div className="flex items-center">{getTypeIcon(item.type)}</div>
            </div>
            <div className="ml-[15px]">
              <div className={styles.title}>{item.label}</div>
              <div className={styles.subtitle}>{item.description}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default AccordionMenu
